import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { Automation, defaultAutomations } from '@/types/automation';

async function getAutomationByEnvironment(environment: string): Promise<Automation[]> {
  try {
    const automationsRef = collection(db, collections.automations);
    const q = query(
      automationsRef,
      where('id', '==', 'evaluator-promo-code'),
      where('environment', '==', 'production')
    );
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      const defaultAutomation = defaultAutomations.find(a => a.id === 'evaluator-promo-code');
      if (!defaultAutomation) {
        throw new Error('Automation configuration not found');
      }
      return [defaultAutomation];
    }

    const automations = snapshot.docs.map(doc => ({
      ...doc.data(),
      id: doc.id
    })) as Automation[];

    return automations;
  } catch (error) {
    console.error('Error fetching automations:', error);
    throw error;
  }
}

async function getAutomationById(id: string): Promise<Automation | null> {
  try {
    // Get direct document reference
    const automationRef = doc(db, collections.automations, id);
    const automationDoc = await getDoc(automationRef);

    if (!automationDoc.exists()) {
      const defaultAutomation = defaultAutomations.find(a => a.id === id);
      if (defaultAutomation) {
        return defaultAutomation;
      }
      throw new Error('Automation configuration not found');
    }

    const data = automationDoc.data();
    
    if (!data.url) {
      throw new Error('Automation URL not configured');
    }

    return {
      ...data,
      id: automationDoc.id
    } as Automation;
  } catch (error) {
    console.error(`Error fetching automation ${id}:`, error);
    throw error;
  }
}

export { getAutomationByEnvironment, getAutomationById };